import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {AccountService, AlertService} from "@app/services";
import {first} from "rxjs";
import {CookiesService} from "@app/services/cookie.service";
import {NotifierService} from "angular-notifier";
import { marker as _i18n } from '@biesbjerg/ngx-translate-extract-marker';

@Component({
  selector: 'app-login',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.sass'],
  providers: [
  ]
})
export class ForgetPasswordComponent implements OnInit {
  form: FormGroup;
  loading = false;
  submitted = false;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private accountService: AccountService,
    private alertService: AlertService,
    private notifierService: NotifierService
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }
  // convenience getter for easy access to form fields
  get f() { return this.form.controls; }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.form.invalid) {
      return;
    }

    this.loading = true;
    this.accountService.forgetPassword(this.f['email'].value).subscribe({
      complete(): void {

      },
      next: (data:any) => {
        this.loading = false;
        if(data.status === "OK"){
          this.notifierService.notify('success', _i18n(`Se ha enviado un correo con un enlace, para restablecer su contraseña`))
          this.router.navigateByUrl("/login");
        }else{
          this.notifierService.notify('error', _i18n(`Ha ocurrido un error, vuelva a intentarlo`))
        }
      },
      error: (error: any) => {
        if(error.error.hasOwnProperty('email')){
          this.notifierService.notify('error', `${error.error.email.join(', ')}`)
        }else{
          this.notifierService.notify('error', _i18n(`Ha ocurrido un error, vuelva a intentarlo`))
        }

        this.loading = false;
      }
    })

  }


}
